import React, { ComponentType } from "react"
import { compose } from "@reduxjs/toolkit"
import { Grid, DialogContent } from "@mui/material"

import { withPaymentMethods } from "hocs/features"
import { useAppDispatch, useAppSelector } from "redux/hooks"
import { closeDialog, selectContent } from "redux/features/dialog/dialogSlice"
import Close from "components/ui/ModalClose"
import BankPayment from "components/Subscription/Modal/Create/BankPayment"
import { PaymentMethodList } from "types"

type Props = {
  paymentMethods: PaymentMethodList
}

const SubscriptionBankPaymentModal = ({ paymentMethods }: Props) => {
  const dispatch = useAppDispatch()

  const content = useAppSelector((state) => selectContent(state))
  const subscriptionId = content.subscriptionId || ""

  const handleClose = () => {
    dispatch(closeDialog())
  }

  return (
    <DialogContent>
      <Close onClick={handleClose} />
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <BankPayment
          subscriptionId={subscriptionId}
          paymentMethods={paymentMethods}
        />
      </Grid>
    </DialogContent>
  )
}

export default compose<ComponentType>(withPaymentMethods)(
  SubscriptionBankPaymentModal,
)
